import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card consent-widget mb-4" }
const _hoisted_2 = {
  key: 0,
  class: "card-body p-0 consent-sign-2"
}
const _hoisted_3 = { class: "px-9 pt-7 card-rounded w-100" }
const _hoisted_4 = { class: "d-flex flex-stack" }
const _hoisted_5 = { class: "m-0 fs-2 consent-widget-text fw-boldest w-100" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "ms-1" }, null, -1)
const _hoisted_7 = { class: "d-flex flex-column pt-2 mt-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { style: {"border-bottom":"1px solid #1bd4cc","width":"100%","float":"left","opacity":"0.5"} }, null, -1)
const _hoisted_9 = { class: "fs-3 consent-widget-text-black mt-3" }
const _hoisted_10 = { class: "px-9 pt-7 fs-5 text-gray-800" }
const _hoisted_11 = { class: "d-flex flex-column" }
const _hoisted_12 = { class: "d-flex flex-column pt-2 process_list" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "fw-boldest fs-6 process_list_number mt-3" }, [
  /*#__PURE__*/_createElementVNode("span", null, "1")
], -1)
const _hoisted_14 = { class: "fs-3 item_title" }
const _hoisted_15 = { class: "fs-6 item_subtitle mb-10" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "fw-boldest fs-6 process_list_number mt-3" }, [
  /*#__PURE__*/_createElementVNode("span", null, "2")
], -1)
const _hoisted_17 = { class: "fs-4 item_title" }
const _hoisted_18 = { class: "fs-6 item_subtitle mb-10" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "fw-boldest fs-6 process_list_number mt-3" }, [
  /*#__PURE__*/_createElementVNode("span", null, "3")
], -1)
const _hoisted_20 = { class: "fs-4 item_title" }
const _hoisted_21 = { class: "fs-6 item_subtitle mb-10" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "fw-boldest fs-6 process_list_number mt-3" }, [
  /*#__PURE__*/_createElementVNode("span", null, "4")
], -1)
const _hoisted_23 = { class: "fs-4 item_title" }
const _hoisted_24 = { class: "fs-6 item_subtitle mb-10" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "fw-boldest fs-6 process_list_number mt-3" }, [
  /*#__PURE__*/_createElementVNode("span", null, "5")
], -1)
const _hoisted_26 = { class: "fs-4 item_title" }
const _hoisted_27 = { class: "fs-6 item_subtitle mb-10" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "px-1 py-1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/media/misc/frame_205.png",
    class: "w-100"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MBloader = _resolveComponent("MBloader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MBloader, { MedicalRecordsTableLoaded: _ctx.isLoaded }, null, 8, ["MedicalRecordsTableLoaded"]),
    (_ctx.isLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t("Free Cancer Clinical Trial Matching")), 1),
              _hoisted_6
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t(
              "Sign to have your medical records collected for a complete review."
            )), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", {
                  class: _normalizeClass(["fs-4 consent-widget-text process_list_item", [
                _ctx.patient_process_status === 1 ? _ctx.item_current : '',
                _ctx.patient_process_status === 2 ? _ctx.item_current_complete : '',
                _ctx.patient_process_status > 2 ? _ctx.item_complete : '',
              ]])
                }, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("Fill out the online questionnaire")), 1),
                  _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("These 7 questions help locate clinical trials for you")), 1)
                ], 2),
                _createElementVNode("div", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToPage('/reports'))),
                  class: _normalizeClass(["fs-4 consent-widget-text process_list_item", [
                _ctx.patient_process_status === 3 ? _ctx.item_current : '',
                _ctx.patient_process_status === 4 ? _ctx.item_current_complete : '',
                _ctx.patient_process_status > 4 ? _ctx.item_complete : '',
              ]])
                }, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("Begin clinical trial matching process")), 1),
                  _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("Receive an initial report of clinical trials near you")), 1)
                ], 2),
                _createElementVNode("div", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToPage('/reports'))),
                  class: _normalizeClass(["fs-4 consent-widget-text process_list_item", [
                _ctx.patient_process_status === 5 ? _ctx.item_current : '',
                _ctx.patient_process_status === 6 ? _ctx.item_current_complete : '',
                _ctx.patient_process_status > 6 && _ctx.patient_process_status !== 12
                  ? _ctx.item_complete
                  : '',
              ]])
                }, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("Sign HIPAA consent form")), 1),
                  _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t(
                    "A patient relations coordinator works with you to understand every step"
                  )), 1)
                ], 2),
                _createElementVNode("div", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToPage('/medical-records'))),
                  class: _normalizeClass(["fs-4 consent-widget-text process_list_item", [
                _ctx.patient_process_status === 7 ? _ctx.item_current : '',
                _ctx.patient_process_status === 8 ? _ctx.item_current_complete : '',
                _ctx.patient_process_status > 8 ? _ctx.item_complete : '',
              ]])
                }, [
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("Upload medical records")), 1),
                  _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t(
                    "Share additional records to determine your eligibility for clinical trials"
                  )), 1)
                ], 2),
                _createElementVNode("div", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToPage('/reports'))),
                  class: _normalizeClass(["fs-4 consent-widget-text process_list_item", [
                _ctx.patient_process_status === 9 || _ctx.patient_process_status === 12
                  ? _ctx.item_current
                  : '',
                _ctx.patient_process_status === 10 ? _ctx.item_current_complete : '',
                _ctx.patient_process_status > 10 && _ctx.patient_process_status !== 12
                  ? _ctx.item_complete
                  : '',
              ]])
                }, [
                  _hoisted_25,
                  _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("Personalized clinical trial matches")), 1),
                  _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$t(
                    "Receive a detailed report with clinical trials you are eligible for"
                  )), 1)
                ], 2)
              ])
            ])
          ]),
          _hoisted_28
        ]))
      : _createCommentVNode("", true)
  ]))
}